import { render } from "./CmsMedia.vue?vue&type=template&id=e1c4c054"
import script from "./CmsMedia.vue?vue&type=script&lang=js"
export * from "./CmsMedia.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__